import {
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';

import { dividerColor } from 'src/data/colors';

import { EquipmentData } from 'src/models';

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 650,
    border: `1px solid ${dividerColor}`,
    borderRadius: 8,
    marginTop: 24,

    [theme.breakpoints.down('sm')]: {
      minWidth: 'unset',
    },
  },
  row: {
    '& td': {
      borderBottom: 'none',
      padding: '8px 16px',

      [theme.breakpoints.down('sm')]: {
        whiteSpace: 'nowrap',
      },
    },
  },
  tableHeader: {
    textTransform: 'uppercase',

    '& th': {
      fontSize: 12,
      fontWeight: 500,
      padding: '8px 16px',
    },
  },
}));

const EquipmentList = ({ equipmentList }: { equipmentList: EquipmentData[] }) => {
  const classes = useStyles();

  return (
    <TableContainer className={classes.table}>
      <Table>
        <TableHead>
          <TableRow className={classes.tableHeader}>
            <TableCell align="left">Model</TableCell>
            <TableCell align="left">Serial number</TableCell>
            <TableCell align="left">Firmware version</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {equipmentList.map((row, index) => (
            <TableRow key={row.serialNumber} className={classes.row}>
              <TableCell align="left">{row.model}</TableCell>
              <TableCell align="left">{row.serialNumber}</TableCell>
              <TableCell align="left">{row.firmwareVersion}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default EquipmentList;
